import React, { useMemo } from "react";
import Logo1 from "../../../assets/images/logo1.png";
import { useSelector } from "react-redux";
import Logo2 from "../../../assets/images/logo2.svg";

const CustomerPaymentPrintHeader = () => {
  const { customerPaymentPrint } = useSelector((state) => state);
  const headerData = customerPaymentPrint && customerPaymentPrint?.payload?.data[0];
  const brand = useMemo(() => new URLSearchParams(window.location.search).get("brand"), []);
  const _logo = brand === "DL1961" ? Logo1 : Logo2;


  return (
    <div className="__header">
      <table width="100%">
        <tbody>
          <tr>
            <td>
              <table width="100%">
                <tbody>
                  <tr>
                    <td width="50%">
                      <table width="100%">
                        <tbody>
                          <tr>
                            <td>
                              <div className="__image_container">
                                <img width={250} height={72} src={_logo} alt="Brand Logo" />
                              </div>
                            </td>
                            <td valign="top" width="100%">
                              <div className="__addr">
                                <p>DLPD CANADA LTD.</p>
                                <p>15 Wertheim Court, Suite 409,</p>
                                <p>Richmond Hill, ON L4B 3H7 , Canada</p>
                                <p>Business # : 763395530RT0001</p>
                                <p>Email : orderca@dl1961.com</p>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                    <td width="50%">
                      <p className="__addr_table_heading">
                        Customer Payment Report
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td width="50%" valign="top" style={{ paddingRight: "5px" }}>
                      <table width="100%" className="__addr_table">
                        <tbody>
                          <tr>
                            <td>Payment No :</td>
                            <td>{headerData?.payment_header_no || ''}</td>
                          </tr>
                          <tr>
                            <td>Customer :</td>
                            <td>{headerData?.customer_name || ''}</td>
                          </tr>
                          <tr>
                            <td>Payment Terms :</td>
                            <td>{headerData?.term_name || ''}</td>
                          </tr>
                          <tr>
                            <td>Payment :</td>
                            <td>{headerData?.payment_type_name || ''}</td>
                          </tr>
                          <tr>
                            <td>Debit Account :</td>
                            <td>{headerData?.debit_acc || ''}</td>
                          </tr>
                          <tr>
                            <td>Gender :</td>
                            <td>{headerData?.gender_name || ''}</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                    <td width="50%" style={{ paddingLeft: "5px" }}>
                      <table width="100%" className="__addr_table">
                        <tbody>
                          <tr>
                            <td>Payment :</td>
                            <td>{headerData?.payment_date || ''}</td>
                          </tr>
                          <tr>
                            <td>Posting Period :</td>
                            <td>{headerData?.period_name || ''}</td>
                          </tr>
                          <tr>
                            <td>Memo :</td>
                            <td>{headerData?.memo || ''}</td>
                          </tr>
                          <tr>
                            <td>A/R Account :</td>
                            <td>{headerData?.credit_acc || ''}</td>
                          </tr>
                          <tr>
                            <td>Currency :</td>
                            <td>{headerData?.currency || ''}</td>
                          </tr>
                          <tr>
                            <td>Remarks :</td>
                            <td>{headerData?.instrument_no || ''}</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default CustomerPaymentPrintHeader;
